import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSync = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.75 8.25H3V4.5M21 12C21 7.029 16.971 3 12 3C8.37 3 5.249 5.154 3.826 8.25M17.25 15.75H21V19.5M3 12C3 16.971 7.029 21 12 21C15.63 21 18.751 18.846 20.174 15.75",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgSync);
export default ForwardRef;
